import React, { useEffect, useState } from "react";
import { BallContainer, Ball, AutoBall, ResultBall } from "./MainStyled";
import useSound from "use-sound";
import useExplosion from "../../explosion";

import winSFX from "../../../assets/audio/mines/winSFX.mp3";
import loseAutoSFX from "../../../assets/audio/mines/loseAutoSFX.mp3";
import loseManualSFX from "../../../assets/audio/mines/loseManualSFX.mp3";
export default ({
  result,
  balls,
  selectedSpheres,
  board,
  isAutoOn,
  handleGameStep,
  manualPlay,
  handleNotification,
  autoAnim,
  perfectWin,
  explosion,
  userSettings,
  stateRound,
  dynamicSoundChange,
}) => {
  const [autoAnimate, setAutoAnimate] = useState(false);
  const [click, setClick] = useState(null);

  const [, , mineLocation, ballsAround] = useExplosion(board, explosion);

  const [playWinSFX] = useSound(winSFX, {
    volume: userSettings.volume,
  });
  const [playLoseAutoSFX] = useSound(loseAutoSFX, {
    volume: userSettings.volume,
  });
  const [playLoseManualSFX] = useSound(loseManualSFX, {
    volume: userSettings.volume,
  });

  const handleSelect = (e) => {
    if (manualPlay && !result) {
      setClick(e);
      handleGameStep(e);
    }
  };
  useEffect(() => {
    setAutoAnimate(autoAnim);
  }, [autoAnim]);

  useEffect(() => {
    if (explosion) {
      userSettings.sound === "1" && playLoseManualSFX();
    }
  }, [explosion, userSettings.sound, playLoseManualSFX]);

  useEffect(() => {
    if (userSettings.sound === "1" && manualPlay && dynamicSoundChange) {
      if (stateRound.bets > 0 && stateRound.state === 1) {
        playWinSFX();
      }
    }
  }, [
    playWinSFX,
    manualPlay,
    stateRound.bets,
    stateRound.state,
    userSettings.sound,
    dynamicSoundChange,
  ]);

  useEffect(() => {
    if (
      isAutoOn &&
      userSettings.sound === "1" &&
      board.length !== 0 &&
      dynamicSoundChange
    ) {
      if (stateRound.state === 3 && stateRound.winAmount > 0) {
        playWinSFX();
      } else if (stateRound.winAmount === 0 && stateRound.state === 2) {
        playLoseAutoSFX();
      }
    }
  }, [
    isAutoOn,
    playWinSFX,
    playLoseAutoSFX,
    board,
    userSettings.sound,
    stateRound.state,
    stateRound.winAmount,
    dynamicSoundChange,
  ]);

  const handleClassNamesManual = (i, b) => {
    return (
      (!result && board[i] === "2" && !perfectWin && b !== "3" && "S") ||
      (result && b === "1" && "R") ||
      (result && (b === "0" || b === "2") && "Y")
    );
  };

  const handleClassNameAutoPlay = (b) => {
    return board.length !== 0
      ? (selectedSpheres.includes(b) &&
          board[parseInt(b)] !== "1" &&
          board[parseInt(b)] !== "3" &&
          "Y") ||
          (!selectedSpheres.includes(b) &&
            board[parseInt(b)] === "1" &&
            "RB") ||
          (!selectedSpheres.includes(b) &&
            board[parseInt(b)] === "0" &&
            "YB") ||
          (selectedSpheres.includes(b) && board[parseInt(b)] === "1" && "R") ||
          (board[parseInt(b)] === "3" && "R")
      : null;
  };
  return (
    <BallContainer>
      {(manualPlay || result) && !isAutoOn
        ? board.map((ball, index) => (
            <ResultBall
              mineLocation={mineLocation}
              isMine={ball === "3"}
              explosion={explosion}
              perfectWin={click === index && perfectWin}
              ballsAround={ballsAround}
              key={index}
              className={handleClassNamesManual(index, ball)}
              onClick={() => handleSelect(index)}
            >
              <span />
              <span />
              <span />
              <span />
            </ResultBall>
          ))
        : isAutoOn
        ? balls.map((ball, index) => (
            <AutoBall
              autoAnimate={autoAnimate}
              className={handleClassNameAutoPlay(ball)}
              key={index}
            >
              <span />
            </AutoBall>
          ))
        : balls.map((ball) => (
            <Ball
              key={ball}
              onClick={() =>
                !manualPlay &&
                handleNotification(
                  "You can't make a selection before placing a bet"
                )
              }
            />
          ))}
    </BallContainer>
  );
};
